/* CarbonPhone – Bundle-Pop-up „Mach dein Smartphone komplett“ (Test-Theme)
   Ablauf: Kunde legt ein Smartphone in den Warenkorb -> statt des Warenkorb-Hinweises erscheint das Pop-up
   mit günstigem Schutz-Zubehör für genau dieses Modell: Displayschutz, Hülle, Linsenschutz (je höchstens eins).
   Gibt es für das Modell nichts davon auf Lager, erscheint kein Pop-up. Hinzugefügt wird nur nach Klick.
   Diese Artikel erscheinen dann nicht mehr in der Box „Passend dazu“ (cp-smart.js) – keine Überschneidung. */

const CHECK = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const CLOSE = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
const SEEN_KEY = 'cp-bundle-seen';

/* Nur günstiges Schutz-Zubehör, das genau zum Modell passt – je Art höchstens ein Teil */
const CATS = [
  ['protect', 'Displayschutz', 'Schutzfolien'],
  ['case', 'Hülle', 'Smartphone-Hüllen'],
  ['lens', 'Linsenschutz', 'Linsenschutz']
];
const CAT_LABEL = Object.fromEntries(CATS.map(([c, l]) => [c, l]));
const TYPE_CAT = Object.fromEntries(CATS.map(([c, , t]) => [t, c]));

const fill = (s, map) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const imgUrl = (src, w) => (src ? `${src}${src.includes('?') ? '&' : '?'}width=${w}` : '');
const seen = () => { try { return JSON.parse(sessionStorage.getItem(SEEN_KEY) || '[]'); } catch (e) { return []; } };
const markSeen = (id) => { try { const s = seen(); if (!s.includes(id)) s.push(id); sessionStorage.setItem(SEEN_KEY, JSON.stringify(s)); } catch (e) {} };

class CpBundle extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    try { this.cfg = JSON.parse(this.querySelector('[data-cp-bundle-config]').textContent); } catch (e) { return; }
    this.cfg.pct = Number(this.cfg.pct) || 0;
    this._onAdd = this.onVariantAdd.bind(this);
    // Capture-Phase: läuft vor dem Warenkorb-Drawer und kann dessen Öffnen verhindern
    document.addEventListener('variant:add', this._onAdd, true);
    // Vorschläge erst laden, wenn jemand Richtung „In den Warenkorb“ geht (spart Anfragen)
    const warm = () => this.load();
    const form = document.querySelector(`form[action*="/cart/add"] [type="submit"]`);
    ['pointerenter', 'touchstart', 'focus'].forEach((ev) => form && form.addEventListener(ev, warm, { once: true, passive: true }));
  }
  disconnectedCallback() { document.removeEventListener('variant:add', this._onAdd, true); }

  /* Kandidaten: erst „Ergänzende Produkte“ aus dem Admin, dann Suche nach Schutz-Zubehör für genau dieses Modell */
  load() {
    if (this._load) return this._load;
    this._load = (async () => {
      const S = await import(this.dataset.smart);
      this.S = S;
      const d = this.dataset;
      const key = S.modelKey(d.title, d.vendor);
      this.model = key;
      const found = {}, used = new Set([d.handle]);
      const tryAdd = async (handle) => {
        if (!handle || used.has(handle)) return;
        used.add(handle);
        const prod = await S.productJson(handle);
        const cat = prod && TYPE_CAT[prod.type];
        if (!cat || found[cat]) return;
        const a = S.analyseAddon(prod, key);
        if (a && a.fit) found[cat] = { prod, a, cat };
      };
      for (const h of (d.handles || '').split('|').filter(Boolean)) await tryAdd(h);
      const types = CATS.map(([, , t]) => 'filter.p.product_type=' + encodeURIComponent(t)).join('&');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const html = await fetch(`${root}search?q=${encodeURIComponent(key)}&type=product&options[prefix]=last&filter.v.availability=1&${types}&section_id=cp-card-strip`)
        .then((r) => (r.ok ? r.text() : '')).catch(() => '');
      const handles = [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('product-card')].map((e) => e.getAttribute('handle'));
      for (const h of handles) {
        if (CATS.every(([c]) => found[c])) break;
        await tryAdd(h);
      }
      return CATS.map(([c]) => found[c]).filter(Boolean);
    })().catch(() => []);
    return this._load;
  }

  onVariantAdd(e) {
    const d = this.dataset, det = e.detail || {};
    const items = det.items || [];
    const mine = items.find((i) => String(i.product_id) === d.productId);
    if (!mine || seen().includes(d.productId)) return;
    // Nur bei Warenkorb als Seitenleiste (drawer) oder Hinweisfenster (popover)
    const tv = window.themeVariables && window.themeVariables.settings;
    this.mode = tv && tv.cartType === 'drawer' && document.querySelector('cart-drawer') ? 'drawer'
      : tv && tv.cartType === 'popover' && document.querySelector('cart-notification-drawer') ? 'popover' : '';
    if (!this.mode) return;
    this.lastCart = det.cart;
    // Was in der Box „Passend dazu“ angehakt ist, kommt ohnehin in den Warenkorb
    const boxHandles = [...document.querySelectorAll('cp-addons input[type="checkbox"]:checked')].map((i) => i.closest('li')?.dataset.handle).filter(Boolean);
    det.blockCartDrawerOpening = true;
    markSeen(d.productId);
    this.open(mine, det.cart, boxHandles);
  }

  async open(line, cart, boxHandles) {
    let list = [];
    try {
      list = await Promise.race([this.load(), new Promise((r) => setTimeout(() => r(null), 4000))]);
    } catch (e) { list = null; }
    const inCart = new Set(((cart && cart.items) || []).map((i) => i.handle));
    boxHandles.forEach((h) => inCart.add(h));
    const avail = (list || []).filter((x) => !inCart.has(x.prod.handle));
    if (!avail.length) { this.showCart(); return; }

    // Ideales Bundle: Displayschutz, Hülle, Linsenschutz – je eins, alle vorausgewählt
    const picked = avail.slice(0, Math.max(1, this.cfg.pre || 3)), extra = [];
    this.render(line, picked, extra);
  }

  render(line, picked, extra) {
    const c = this.cfg, pct = c.pct;
    const dlg = document.createElement('dialog');
    dlg.className = 'cp-bundle';
    dlg.setAttribute('aria-labelledby', 'cp-bundle-h');
    const title = fill(c.title, { modell: this.model });
    const sub = pct > 0 && c.subPct ? esc(fill(c.subPct, { prozent: pct })).replace(/(\d+\s?%)/, '<strong>$1</strong>') : esc(c.sub);
    const variant = line.variant_title && !/default title/i.test(line.variant_title) ? ' – ' + line.variant_title : '';
    dlg.innerHTML = `
      <div class="cp-bundle__top">
        ${line.image ? `<img src="${esc(imgUrl(line.image, 120))}" alt="" width="44" height="44">` : '<span></span>'}
        <p class="cp-bundle__added"><b>${CHECK} Im Warenkorb</b><span>${esc(line.product_title + variant)}</span></p>
        <button type="button" class="cp-bundle__x" data-no aria-label="Schließen">${CLOSE}</button>
      </div>
      <div class="cp-bundle__body">
        <h2 class="cp-bundle__h" id="cp-bundle-h" tabindex="-1">${esc(title)}</h2>
        <p class="cp-bundle__sub">${sub}</p>
        <p class="cp-bundle__label">Dein ideales Bundle</p>
        <ul class="cp-bundle__list" role="list" data-picked></ul>
        ${extra.length ? '<p class="cp-bundle__label">Ebenfalls passend</p><ul class="cp-bundle__list" role="list" data-extra></ul>' : ''}
      </div>
      <div class="cp-bundle__foot">
        <div class="cp-bundle__sum"><span data-count></span><span><span data-total></span> <span class="cp-bundle__save" data-save hidden></span></span></div>
        <p class="cp-bundle__note" data-note ${pct > 0 && c.note ? '' : 'hidden'}>${esc(fill(c.note, { prozent: pct, anzahl: c.max }))}</p>
        <p class="cp-bundle__err" role="alert" data-err hidden></p>
        <div class="cp-bundle__btns">
          <button type="button" class="cp-bundle__go" data-go></button>
          <button type="button" class="cp-bundle__no" data-no>${this.mode === 'drawer' ? 'Nein danke, weiter zum Warenkorb' : 'Nein danke'}</button>
        </div>
      </div>`;
    const ulP = dlg.querySelector('[data-picked]'), ulE = dlg.querySelector('[data-extra]');
    this.rows = [];
    picked.forEach((x) => ulP.appendChild(this.item(x, true)));
    extra.forEach((x) => ulE.appendChild(this.item(x, false)));

    dlg.querySelectorAll('[data-no]').forEach((b) => b.addEventListener('click', () => this.close(true)));
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); this.close(true); });
    dlg.addEventListener('click', (e) => { if (e.target === dlg) this.close(true); });
    dlg.querySelector('[data-go]').addEventListener('click', () => this.submit());
    this.dlg = dlg;
    this.appendChild(dlg);
    document.documentElement.classList.add('cp-bundle-lock');
    dlg.showModal();
    dlg.querySelector('#cp-bundle-h').focus();
    this.update();
  }

  /* Eine Zeile: Häkchen, Bild, Kategorie, Name, „passend für“, Preis (mit Rabatt), ggf. Optionen */
  item(x, on) {
    const { prod, a } = x;
    const li = document.createElement('li');
    li.innerHTML = `<label class="cp-bundle__item"><input type="checkbox"><span class="cp-bundle__img"><img alt="" loading="lazy" width="56" height="56"></span><span class="cp-bundle__info"><span class="cp-bundle__cat"></span><span class="cp-bundle__name"></span><span class="cp-bundle__fit" hidden>${CHECK}<span></span></span></span><span class="cp-bundle__price"></span></label>`;
    li.querySelector('.cp-bundle__cat').textContent = CAT_LABEL[x.cat];
    li.querySelector('.cp-bundle__name').textContent = prod.title;
    if (a.fit && a.modelLabel) {
      const f = li.querySelector('.cp-bundle__fit');
      f.lastElementChild.textContent = 'passend für ' + a.modelLabel;
      f.hidden = false;
    }
    const cb = li.querySelector('input');
    cb.checked = on;
    li.classList.toggle('is-on', on);
    const eligible = this.cfg.pct > 0 && (prod.tags || []).some((t) => t.toLowerCase() === String(this.cfg.tag).toLowerCase());
    const row = { li, cb, prod, variant: a.def, eligible };
    const apply = (v) => {
      row.variant = v;
      cb.value = v.id;
      const s = imgUrl((v.featured_image && v.featured_image.src) || prod.featured_image || '', 160);
      if (s) li.querySelector('img').src = s;
      this.update();
    };
    cb.addEventListener('change', () => { li.classList.toggle('is-on', cb.checked); this.update(); });
    if (a.choices.length) {
      const box = document.createElement('div');
      box.className = 'cp-bundle__opts';
      const sels = a.choices.map((ch) => {
        const w = document.createElement('label');
        w.className = 'cp-bundle__opt';
        const sel = document.createElement('select');
        sel.dataset.idx = ch.idx;
        sel.setAttribute('aria-label', ch.name + ' für ' + prod.title);
        ch.values.forEach((val) => { const o = document.createElement('option'); o.value = o.textContent = val; sel.appendChild(o); });
        sel.value = a.def.options[ch.idx];
        const sp = document.createElement('span'); sp.textContent = ch.name;
        w.append(sp, sel);
        box.appendChild(w);
        return sel;
      });
      sels.forEach((sel) => sel.addEventListener('change', () => {
        let v = a.vars.find((vv) => sels.every((s) => vv.options[s.dataset.idx] === s.value));
        if (!v) v = a.vars.find((vv) => vv.options[sel.dataset.idx] === sel.value) || a.def;
        sels.forEach((s) => { s.value = v.options[s.dataset.idx]; });
        cb.checked = true;
        li.classList.add('is-on');
        apply(v);
      }));
      li.appendChild(box);
    }
    this.rows.push(row);
    row.variant = a.def;
    cb.value = a.def.id;
    const s0 = imgUrl((a.def.featured_image && a.def.featured_image.src) || prod.featured_image || '', 160);
    if (s0) li.querySelector('img').src = s0;
    return li;
  }

  /* Preise und Summe neu berechnen. Rabatt vorsichtig: höchstens „max“ Artikel, die günstigsten zuerst. */
  update() {
    if (!this.dlg || !this.rows) return;
    const S = this.S, pct = this.cfg.pct, max = this.cfg.max || 3;
    const on = this.rows.filter((r) => r.cb.checked);
    const disc = new Set(on.filter((r) => r.eligible).sort((a, b) => a.variant.price - b.variant.price).slice(0, max));
    let total = 0, save = 0;
    this.rows.forEach((r) => {
      const price = r.variant.price;
      // Rabatt anzeigen, wenn der Artikel (angehakt) rabattiert wird – bei nicht angehakten: wenn noch Platz wäre
      const would = r.eligible && (r.cb.checked ? disc.has(r) : disc.size < max);
      const net = would ? Math.round(price * (100 - pct) / 100) : price;
      r.li.querySelector('.cp-bundle__price').innerHTML = would
        ? `<em>−${pct} %</em><span>${S.money(net)}</span><s>${S.money(price)}</s>`
        : `<span>${S.money(price)}</span>`;
      if (r.cb.checked) { total += net; save += price - net; }
    });
    const n = on.length;
    this.dlg.querySelector('[data-count]').textContent = n === 1 ? '1 Artikel ausgewählt' : `${n} Artikel ausgewählt`;
    this.dlg.querySelector('[data-total]').innerHTML = n ? (save > 0 ? `<s>${S.money(total + save)}</s><b>${S.money(total)}</b>` : `<b>${S.money(total)}</b>`) : '';
    const sv = this.dlg.querySelector('[data-save]');
    sv.hidden = !(save > 0);
    sv.textContent = `Du sparst ${S.money(save)}`;
    const go = this.dlg.querySelector('[data-go]');
    go.disabled = n === 0;
    go.textContent = n === 0 ? 'Nichts ausgewählt' : n === 1 ? '1 Artikel hinzufügen' : `Bundle hinzufügen (${n} Artikel)`;
  }

  async submit() {
    const on = this.rows.filter((r) => r.cb.checked);
    if (!on.length) return;
    const go = this.dlg.querySelector('[data-go]'), err = this.dlg.querySelector('[data-err]');
    go.setAttribute('aria-busy', 'true');
    go.disabled = true;
    err.hidden = true;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: on.map((r) => ({ id: r.variant.id, quantity: 1 })), sections: 'cart-drawer' })
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Fehler');
      const cart = await (await fetch(`${root}cart.js`)).json();
      cart.sections = json.sections || {};
      // Warenkorb-Zähler und ggf. Seitenleiste aktualisieren
      if (cart.sections['cart-drawer'] || !document.querySelector('cart-drawer')) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
      document.querySelectorAll('cart-count').forEach((el) => { try { el.itemCount = cart.item_count; } catch (e) {} });
      if (this.mode === 'drawer') this.close(true);
      else this.done(on.length);
    } catch (e) {
      go.removeAttribute('aria-busy');
      go.disabled = false;
      err.textContent = 'Ein Artikel konnte gerade nicht hinzugefügt werden (evtl. nicht mehr vorrätig). Bitte Auswahl anpassen.';
      err.hidden = false;
    }
  }

  /* Bestätigung nach dem Hinzufügen (Warenkorb als Hinweisfenster) */
  done(n) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const c = this.cfg;
    this.dlg.querySelector('.cp-bundle__body').innerHTML = `<h2 class="cp-bundle__h" id="cp-bundle-h" tabindex="-1">${CHECK.replace('width="12" height="12"', 'width="20" height="20"')} ${n === 1 ? '1 Artikel' : n + ' Artikel'} hinzugefügt</h2><p class="cp-bundle__sub">${c.pct > 0 && c.note ? esc(fill(c.note, { prozent: c.pct, anzahl: c.max })) : 'Dein Smartphone und das Zubehör liegen im Warenkorb.'}</p>`;
    this.dlg.querySelector('.cp-bundle__foot').innerHTML = `<div class="cp-bundle__btns"><a class="cp-bundle__go" href="${root}cart">Zum Warenkorb</a><button type="button" class="cp-bundle__no" data-no>Weiter einkaufen</button></div>`;
    this.finished = true;
    this.dlg.querySelector('.cp-bundle__foot [data-no]').addEventListener('click', () => this.close(false));
    this.dlg.querySelector('#cp-bundle-h').focus();
  }

  close(toCart) {
    if (this.finished) { toCart = false; this.finished = false; }
    if (this.dlg) {
      this.dlg.close();
      this.dlg.remove();
      this.dlg = null;
    }
    document.documentElement.classList.remove('cp-bundle-lock');
    if (toCart) this.showCart();
  }

  /* Verhalten wie ohne Pop-up: Seitenleiste öffnen bzw. Hinweis „Zum Warenkorb hinzugefügt“ zeigen */
  showCart() {
    if (this.mode === 'popover') {
      const n = document.querySelector('cart-notification-drawer');
      const html = this.lastCart && this.lastCart.sections && this.lastCart.sections['variant-added'];
      if (n && html) {
        const t = document.createElement('div');
        t.innerHTML = html;
        const sec = t.querySelector('.shopify-section');
        if (sec) { n.replaceChildren(...sec.children); n.show(); return; }
      }
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') drawer.show();
  }
}
if (!customElements.get('cp-bundle')) customElements.define('cp-bundle', CpBundle);
